import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import Tabs, { ITab } from "@/components/Tabs";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";

const PrivacyCenterController = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname.endsWith("privacy-centre")) navigate("theme");
  }, [pathname]);

  const tabs: ITab[] = [
    {
      title: t("comply.privacyCenter.tabs.theme"),
      path: "theme",
    },
    {
      title: t("comply.privacyCenter.tabs.language"),
      path: "language",
    },
    {
      title: t("comply.privacyCenter.tabs.preview"),
      path: "preview",
    },
    {
      title: t("comply.privacyCenter.tabs.websiteInstallation"),
      path: "website-installation",
    },
  ];

  const getHeaderText = (pathName: string) => {
    const path = pathName.split("/").filter(Boolean).pop();
    switch (path) {
      case "theme":
        return {
          feature: t("comply.privacyCenter.theme.header.feature"),
          heading: t("comply.privacyCenter.theme.header.heading"),
          description: t("comply.privacyCenter.theme.header.description"),
        };
      case "preview":
        return {
          feature: t("comply.privacyCenter.preview.header.feature"),
          heading: t("comply.privacyCenter.preview.header.heading"),
          description: t("comply.privacyCenter.preview.header.description"),
        };
      case "website-installation":
        return {
          feature: t("comply.privacyCenter.websiteInstallation.header.feature"),
          heading: t("comply.privacyCenter.websiteInstallation.header.heading"),
          description: t(
            "comply.privacyCenter.websiteInstallation.header.description",
          ),
        };
      case "language":
        return {
          feature: t("comply.privacyCenter.language.header.feature"),
          heading: t("comply.privacyCenter.language.header.heading"),
          description: t("comply.privacyCenter.language.header.description"),
        };
    }
  };

  const renderHeader = () => {
    const headerText = getHeaderText(pathname);
    return (
      <TypographyContainer>
        <HeaderTextBlock
          align="left"
          featureText={headerText?.feature}
          headingText={headerText?.heading}
          descriptionText={headerText?.description}
        />
      </TypographyContainer>
    );
  };

  const renderTabs = () => (
    <div className="mt-2">
      <Tabs tabs={tabs} />
      <div className="mt-25">
        <Outlet />
      </div>
    </div>
  );

  return (
    <>
      {renderHeader()}
      {renderTabs()}
    </>
  );
};

export default PrivacyCenterController;
